// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"FrameCell__ellipsis__2CTE9","flex-child-ellipsis":"FrameCell__flex-child-ellipsis__11C8F","multiplayer-cursor":"FrameCell__multiplayer-cursor__2XTtb"};